<template>
    <v-app id="confirmation-dialog" v-if="dialogStatus" :class="dialogStatus ? 'addHeight': ''">
        <v-dialog :max-width="width" :value="dialogStatus" persistent class="dialog__container">
            <v-card class="confirmation-dialog-card">
                <v-card-title class="pt-4">
                    <p class="confirmation-title" v-text="title"></p>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="sendInfoToParent('close')" class="closeIcon" title="close">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    <div class="popup-content">
                        <slot></slot>
                    </div>
                </v-card-text>
        
                <v-card-actions class="pb-6">
                    <v-spacer></v-spacer>
                        <v-btn v-for="(action, index) in actions" :key="index"
                        depressed
                        :class="[index == 0 ? (enableFreemiumTheme ? 'verified-dis-btn':'disable__cd' ):( enableFreemiumTheme? 'verified-ena-btn':'enable__cd') ,action.status==='disable'? 'complete-disable': 'complete-enable' ]"
                        v-text="action.text"
                        @click="sendInfoToParent(action)"
                        >
                        </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>
<script>
import Vue from 'vue'
export default {
    name: 'confirmationDialog',
    props: {
        enableFreemiumTheme: {
            type:Boolean,
            default:false
        },
        dialogStatus: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: "Remove Company"
        },
        width: {
            type: Number,
            default: 576
        },
        actions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        eventName: {
          type: String,
          default: ""
        }
    },
    data() {
        return {
            // 
        } 
    },
    methods: {
        sendInfoToParent(data) {
            var self = this;
            if (data == 'close') {
                let modalStatus = {}; 
                modalStatus['action'] = data;
                data = modalStatus;
            } 
            data['dialogStatus'] = self.dialogStatus;
            self.$emit(self.eventName, data);
        }
    }
}
</script>
<style lang="scss">
@import '../../assets/scss/utils/colors.scss';
#confirmation-dialog, .confirmation-dialog-card {
    font-family: 'TitilliumWeb-Regular';
    .v-card.v-sheet.theme--light {
        padding: 1rem;
    }
    .v-dialog.v-dialog--active.v-dialog--persistent {
        overflow-y: unset !important;
    }
    .v-card__text {
        width: auto;
        font-size: 1rem;
        color: #28292B !important;
        padding-top: 0rem ;
    }
    .verified-ena-btn.theme--light.v-btn {
        background-color: $freemium-theme;
        color: #FFFFFF;
    }
    .verified-dis-btn.theme--light.v-btn:hover {
        color: $freemium-theme;
        background-color: #FFFFFF;
    }

    .enable__cd.theme--light.v-btn {
        background-color: $mxp-theme;
        color: #FFFFFF;
    }
    .disable__cd.theme--light.v-btn:hover {
        color: #E34E25;
        background-color: #FFFFFF;
    }
    .complete-disable.theme--light.v-btn {
        cursor: not-allowed;
        opacity: 0.5;
        pointer-events: none;
    }
    .complete-enable {
        pointer-events: all;
        cursor: pointer;
        opacity: 1;
    }
    .closeIcon {
        margin-top: -2rem;
        margin-right: -1.2rem;
        color: #8C857E;
    }
    .confirmation-title {
        font-size: 1.42rem; /* 20px approx*/
        color: #28292B;
    }
    .popup-content {
        // width: 95%;
    }
}
#confirmation-dialog {
    &.v-dialog>.v-card>.v-card__actions {
        padding: 1.5rem;
    }
}
.confirmation-dialog-card {
    border-radius: 0px;
    .v-card__title {
        height: 4rem;
        .v-btn__content > .v-icon {
            font-size: 1.2rem;
        }
        .v-card__text {
            padding: 0px 24px 24px;
        }
    }
    .v-card__actions > .v-btn {
        // width: 7rem;
        border-radius: 0px;
    }
    .v-text-field {
        padding-top: 0rem !important;
    }
}
.addHeight {
    height: 0;
}
</style>
